export default __webpack_public_path__ + "static/media/bridge.eb81da29.svg";